import type { SessionState } from './types';

const initialState: SessionState = {
  appSessionId: null,
  appSessionStart: null,
  appSessionStartPerfTime: null,
  isExpired: false,
  lastActivity: null,
  lastActivityPerfTime: null,
  userSessionId: null,
  userSessionStart: null,
  userSessionStartPerfTime: null,
};

export default initialState;
